import { createTheme, PaletteMode, ThemeOptions } from "@mui/material";
import { Typography } from "./typography";

export default function Theme(darkMode: boolean = false) {
  const themeTypography = Typography(`'Inter', 'Roboto', sans-serif`);

  const themeBreakpoints = {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  };

  const themePalette = {
    mode: (darkMode ? "dark" : "light") as PaletteMode,
    primary: {
      main: darkMode ? "#818CF8" : "#6366F1",
      light: darkMode ? "#A5B4FC" : "#818CF8",
      dark: darkMode ? "#6366F1" : "#4F46E5",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: darkMode ? "#A78BFA" : "#8B5CF6",
      light: darkMode ? "#C4B5FD" : "#A78BFA",
      dark: darkMode ? "#8B5CF6" : "#7C3AED",
      contrastText: "#FFFFFF",
    },
    error: {
      main: darkMode ? "#F87171" : "#EF4444",
      light: darkMode ? "#FCA5A5" : "#F87171",
      dark: darkMode ? "#EF4444" : "#DC2626",
    },
    warning: {
      main: darkMode ? "#FBBF24" : "#F59E0B",
      light: darkMode ? "#FCD34D" : "#FBBF24",
      dark: darkMode ? "#F59E0B" : "#D97706",
    },
    success: {
      main: darkMode ? "#34D399" : "#10B981",
      light: darkMode ? "#6EE7B7" : "#34D399",
      dark: darkMode ? "#10B981" : "#059669",
    },
    text: {
      primary: darkMode ? "#E2E8F0" : "#2F2F2F",
      secondary: darkMode ? "#94A3B8" : "#6C6C6C",
    },
    background: {
      default: darkMode ? "#1E293B" : "#F9F5EF",
      paper: darkMode ? "#334155" : "#FFFFFF",
    },
    divider: darkMode ? "#475569" : "#E5E7EB",
    action: {
      hover: darkMode ? "#475569" : "#F3F4F6",
      selected: darkMode ? "#64748B" : "#E0E7FF",
      disabled: darkMode ? "#64748B" : "#9CA3AF",
    },
  };

  const ThemeOptions: ThemeOptions = {
    breakpoints: themeBreakpoints,
    palette: themePalette,
    typography: themeTypography,
    shape: {
      borderRadius: 10,
    },
    components: {
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: darkMode ? "#0F172A" : "#FFFFFF",
            color: darkMode ? "#E2E8F0" : "#2F2F2F",
            boxShadow: darkMode ? "0 1px 3px 0 rgba(0, 0, 0, 0.3)" : "0 2px 4px rgba(0,0,0,0.05)",
            borderBottom: `1px solid ${darkMode ? "#475569" : "#EEE"}`,
            borderRadius: 0,
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundColor: darkMode ? "#334155" : "#FFFFFF",
            boxShadow: darkMode ? "0 1px 3px 0 rgba(0, 0, 0, 0.3)" : "0 2px 4px rgba(0,0,0,0.05)",
            borderRadius: 10,
            border: `1px solid ${darkMode ? "#475569" : "#EEE"}`,
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
            fontWeight: 500,
            borderRadius: 6,
            padding: "12px 20px",
            fontSize: "14px",
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            boxShadow: darkMode ? "0 1px 3px 0 rgba(0, 0, 0, 0.3)" : "0 2px 4px rgba(0,0,0,0.05)",
            borderRadius: 10,
            border: `1px solid ${darkMode ? "#475569" : "#EEE"}`,
            backgroundColor: darkMode ? "#334155" : "#FFFFFF",
          },
        },
      },
      MuiTableRow: {
        styleOverrides: {
          root: {
            "&:not(:last-child)": {
              borderBottom: `1px solid ${darkMode ? "#475569" : "#E5E7EB"}`,
            },
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            borderBottom: `1px solid ${darkMode ? "#475569" : "#E5E7EB"}`,
          },
        },
      },
    },
  };

  return createTheme(ThemeOptions);
}
